<template>
  <div>
    <!-- 标题 -->
    <!-- <div>
      <van-nav-bar
        title="社区资讯"
      />
    </div> -->
    <!-- tab栏 -->
    <van-sticky>
      <van-tabs @click="onClickOnlyOne"
        color="#0f97ff"
        title-active-color="#0f97ff">
        <van-tab name="0"
          title="全部">
        </van-tab>
        <van-tab v-for="item in RIKindList"
          :key="item.Id"
          :name="item.Id"
          :title="item.Name">
        </van-tab>
      </van-tabs>
    </van-sticky>

    <div class="information">
      <!-- 全部 -->
      <div class="center borderClass"
        v-for="item in list"
        :key="item.index">
        <div @click="gotoUrl('/article/detail/' +
          item.RIId)">

          <div class="Content">
            <div style="display: inline-block; width: 30%"
              class="ContentA"
              ref="getHeight">
              <img v-if="item.Thematic"
                style="border-radius:5px;min-height: 88px;"
                :src="item.Thematic"
                alt="" />
            </div>
            <div style="display: inline-block; width: 63%"
              class="ContentB">
              <div class="centerTitle van-multi-ellipsis--l2">
                {{ item.Title }}
              </div>
              <span class="centertime van-multi-ellipsis--l2"
                style="margin:5px 0px;font-size: 13px;color: #666666;">{{ item.Summary }}</span>
            </div>
            <span class="centertime"
              style="float: right; margin-top: -15px;color:black;">{{
              item.IssTime | timeFilter
            }} <span style="padding-left:10px;">{{item.ReadNum}} 阅读</span> </span>
          </div>
        </div>
      </div>
      <!-- 没有更多数据了 -->
      <div v-if="hidden"
        class="hidden">── 没有更多数据了 ──</div>
    </div>
  </div>
</template>
<script>
import { setOpenId, getOpenId } from "@/utils/auth";
import { WeGetRealInfoPage, WeGetInfoKindInfoPage } from "@/api/RealInfo";
export default {
  data () {
    return {
      tkId: 0, //tab栏
      activeName: "",
      list: {}, //资讯列表
      listfrom: {
        page: 1,
        limit: 10,
        riKind: 0,
      }, //查询传参
      hidden: true, //没有更多数据了
      TitleList: [],
      RIKindList: [
        { Id: 1, Name: '法律法规' },
        { Id: 2, Name: '新闻资讯' },
        { Id: 3, Name: '养老知识' },
        { Id: 4, Name: '养老动态' },
      ],
    };
  },
  filters: {
    timeFilter (value) {
      if (value != undefined) {
        let gstime = value.replace('T', ' ')
        return gstime;
      }
    }
  },
  methods: {
    //跳转到公共页面
    gotoUrl (path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },
    // 获取分页列表 
    getList () {
      WeGetRealInfoPage(this.listfrom)
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.count == 0) {
              this.list = {};
            } else {
              this.list = res.data.data;
              for (var i = 0; i < this.list.length; i++) {
                if (this.list[i].ThematicUrl == "") {
                  this.list[i].ThematicUrl =
                    "http://cuiyunapi.dexian.ren//upload/images/2021/7/873b94ff-81d.png";
                }
              }
            }
          }
        })
        .catch(() => { });
    },
    // tab点击切换事件
    onClick (name, title) {
      this.list = []
      this.listfrom.riKind = name
      this.listfrom.page = 1
      this.getList()
    },
    onClickOnlyOne (name, title) {
      this.list = []
      this.listfrom.riKind = name
      this.listfrom.page = 1
      this.getList()
    },
  },
  mounted () {
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }
    this.getList()
    // this.getPBActivityList()
  },
};
</script>
<style scoped>
.hidden {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin: 10px 0px 25px 0px;
}
.information {
  width: 95%;
  margin: auto;
}
.borderClass {
  padding: 0;
  box-shadow: 0px 5px 17px 1px rgb(0 0 0 / 7%);
}
.borderClass .Content {
  padding: 8px;
  margin-top: 10px;
}
</style>